import type { RCard } from 'v2/types/api/billing'

/** The "no card" sentinel every caller already tests against. */
const NO_CARD = 0

/**
 * The card a checkout should actually charge, given what the user picked and
 * what is still in the list.
 *
 * Selected if it is still there, else the default card, else the first one. Held
 * in one place because four modals had spelled the same memo out, and because the
 * card picker can now DELETE a card: the list can lose the selected card while a
 * modal is open, and a modal that keeps raw state then submits a
 * `card_mapping_id` the backend no longer knows. `upgrade-downgrade-modal` had
 * exactly that hole — it re-selected only on the modal's open transition.
 *
 * Deriving on every render rather than syncing state in an effect is deliberate:
 * an effect would render one frame with the dead id, which is the frame a fast
 * click submits in.
 */
export const resolveSelectedCardId = (activeCards: RCard[], selectedCardId: number): number => {
  if (activeCards.length === 0) return NO_CARD
  if (activeCards.some((card) => card.card_mapping_id === selectedCardId)) return selectedCardId
  return activeCards.find((card) => card.default)?.card_mapping_id ?? activeCards[0].card_mapping_id
}
